import {useTranslation} from 'react-i18next';
import {useCustomTheme} from 'context/customTheme';
import {Gift} from 'lucide-react';
import clsx from 'clsx';
import styles from './styles.module.css';

type Props = {
  className?: string;
};
export const Banner = ({className}: Props) => {
  const {t} = useTranslation();
  const {finalTheme} = useCustomTheme();

  return (
    <div
      className={clsx(styles.guruwalkWidget__banner, className)}
      style={{
        background: finalTheme.colors.buttons.mainButtonBackground,
        color: finalTheme.colors.buttons.mainButtonTextBackground,
      }}
    >
      <Gift size={24} color={finalTheme.colors.buttons.mainButtonTextBackground} />
      <span>{t('guruwalk_banner')}</span>
    </div>
  );
};
